import locales from './locales';
import toWebpImage from '@src/utils/to-webp-image';

const getImgSrc = (level, mechaType, filename) => {
  let path = './images/airmen';
  if (level) {
    path += '/' + level;
  }
  if (mechaType) {
    // TODO TEST
    path += '/' + mechaType;
  }
  return toWebpImage(require(`${path}/${filename}`));
};

/**
 * @typedef {Object} MechaLevel
 * @property {string} PAWN 杂兵
 * @property {string} ACE 精英
 * @property {string} BOSS 精英首领
 *
 * @type {MechaLevel}
 * @description 机兵等级枚举
 */
export const MECHA_LEVEL = {
  PAWN: 'pawn',
  ACE: 'ace',
  BOSS: 'boss'
};

/**
 * @typedef {Object} Airmen
 * @property {string} id 机兵id
 * @property {string} name 机兵名称
 * @property {string} schematic 机兵概率图
 * @property {Array<Mecha>} mechaType 机兵类型
 *
 * @typedef {Object} Mecha
 * @property {string} modalTab 机兵详情弹窗tab
 * @property {string} pedigreeChart 机兵谱系图
 * @property {string} mecha 机兵图片
 * @property {string} blockLeft
 * @property {string} blockRight
 *
 * @type {Array<Airmen>}
 * @description 机兵数据
 */
let airmen = [
  {
    id: MECHA_LEVEL.PAWN,
    name: locales.pawn,
    mechaType: [
      //#region 伏虎
      {
        id: 'fuhu-a',
        threatLevel: '中',
        type: '突击装备',
        name: '伏虎 T型',
        number: 'OET-BO1',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '19.0t'
          },
          {
            name: '头顶高',
            value: '13.9m'
          },
          {
            name: '全重',
            value: '24.7t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '13.9m'
          },
          {
            name: '重量',
            value: '24.7t'
          }
        ],
        background: '“伏虎”是战略同盟开发的第一型军用机兵，轻便可靠且易于量产，大量装备同盟军队的同时也远销海外。',
        armedMessage: [
          '“惊弦”霰弹炮：“惊弦”霰弹炮是欧冶电科研发的第一型手持式霰弹炮，只需一发就能彻底摧毁轻型载具。其弹药按特定序列交替填充穿甲霰弹和两种发射药，确保每枚弹丸都有足够的穿透力。',
          '“鳞羽”轻型导弹：“鳞羽”轻型导弹为便于机兵搭载限制了体积，性能屡遭军事观察家质疑。然而，鉴于它供应量充足到可对战场上任何可疑玩意都发送几枚，单凭舆论显然无法撼动它的地位。'
        ],
        modalAvatar: getImgSrc('pawn', 'fuhu-a', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'fuhu-a', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'fuhu-a', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'fuhu-a', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'fuhu-a', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'fuhu-a', 'block-right-hover.png')
      },
      {
        id: 'fuhu-b',
        threatLevel: '中',
        type: '标准装备',
        name: '伏虎 B型',
        number: 'OET-BO1',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '19.0t'
          },
          {
            name: '头顶高',
            value: '13.9m'
          },
          {
            name: '全重',
            value: '24.7t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '13.9m'
          },
          {
            name: '重量',
            value: '24.7t'
          }
        ],
        background: '“伏虎”是战略同盟开发的第一型军用机兵，轻便可靠且易于量产，大量装备同盟军队的同时也远销海外。',
        armedMessage: [
          '“征铎”速射炮：“征铎”速射炮是某型防空机炮的手持化版本，针对EIC污染重点优化了防尘性能。同盟通过该武装的研发和测试更新了适应灾后环境的可靠性验收标准，为新装备开发奠定了基础。',
          '“碣石”防盾：“碣石”格斗防盾是同盟为其二代机兵配发的基础防护套件。同盟宣称它可将机兵的战斗损失降低百分之十五，鉴于战乱地区能轻易购得完好的同盟机兵左臂，这一数字或许还算可信。'
        ],
        modalAvatar: getImgSrc('pawn', 'fuhu-b', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'fuhu-b', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'fuhu-b', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'fuhu-b', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'fuhu-b', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'fuhu-b', 'block-right-hover.png')
      },
      {
        id: 'fuhu-c',
        threatLevel: '中',
        type: '炮击装备',
        name: '伏虎 P型',
        number: 'OET-BO1',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '19.0t'
          },
          {
            name: '头顶高',
            value: '13.9m'
          },
          {
            name: '全重',
            value: '24.7t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '13.9m'
          },
          {
            name: '重量',
            value: '24.7t'
          }
        ],
        background: '“伏虎”是战略同盟开发的第一型军用机兵，轻便可靠且易于量产，大量装备同盟军队的同时也远销海外。',
        armedMessage: [
          '“托约尔”榴弹炮：“托约尔”榴弹炮是云回工业研发的炮击武装，威力优秀但体积庞大。中小型机体搭载该炮时很难运用其他手持式武装，但这一缺点无法掩盖该武装令人欲罢不能的爆炸威力。',
          '“月华”防御力场：“月华”防御力场是同盟近年推广的廉价型号，能为缺乏流体装甲保护的第二代机兵提供基本的防护能力。二代机的级联引擎较为原始，发电能力有限，限制了该型力场的性能。'
        ],
        modalAvatar: getImgSrc('pawn', 'fuhu-c', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'fuhu-c', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'fuhu-c', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'fuhu-c', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'fuhu-c', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'fuhu-c', 'block-right-hover.png')
      },
      {
        id: 'fuhu-d',
        threatLevel: '中',
        type: '工兵装备',
        name: '伏虎 V型',
        number: 'OET-BO1',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '19.0t'
          },
          {
            name: '头顶高',
            value: '13.9m'
          },
          {
            name: '全重',
            value: '24.7t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '13.9m'
          },
          {
            name: '重量',
            value: '24.7t'
          }
        ],
        background: '“伏虎”是战略同盟开发的第一型军用机兵，轻便可靠且易于量产，大量装备同盟军队的同时也远销海外。',
        armedMessage: [
          '“晓钟”战锤：“晓钟”战锤是同盟工兵部队广泛装备的手持式武装，以其命中重装甲目标时的鸣响有如钟声而得名。虽然它的主业是粉碎残骸和障碍物，但它也能三两下将敌军载具砸成废铁。',
          '“长缨”轻型照射炮：“长缨”照射炮是同盟以“等离子焊枪”为代号秘密开发的超高功率照射炮。据某位曾参与环海冲突的老兵透露，若是正确调节该武装的射束功率，似乎确实能用它焊接舰船装甲……'
        ],
        modalAvatar: getImgSrc('pawn', 'fuhu-d', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'fuhu-d', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'fuhu-d', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'fuhu-d', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'fuhu-d', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'fuhu-d', 'block-right-hover.png')
      },
      //#endregion
      //#region 胄虎
      {
        id: 'zhouhu-a',
        threatLevel: '中',
        type: '炮击装备',
        name: '胄虎坦克 P型',
        number: 'OET-T01L',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '32.0t'
          },
          {
            name: '头顶高',
            value: '8.6m'
          },
          {
            name: '全重',
            value: '41.8t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '8.6m'
          },
          {
            name: '重量',
            value: '41.8t'
          }
        ],
        background: '“胄虎坦克”是民用履带底盘与军用机兵躯干拼凑而成的重型机体，通常搭载大型武装用于火力支援。',
        armedMessage: [
          '“阿斯旺”能量炮：“阿斯旺”能量炮是近年云回工业针对当地潮湿气候开发的新型武装，以简洁的密封框架隔绝了水汽和沙尘，无惧丛林、沙漠、海岛等各类严苛环境，唯独难以适应高寒地带。',
          '“月华”防御力场：“月华”防御力场是同盟近年推广的廉价型号，能为缺乏流体装甲保护的第二代机兵提供基本的防护能力。二代机的级联引擎较为原始，发电能力有限，限制了该型力场的性能。'
        ],
        modalAvatar: getImgSrc('pawn', 'zhouhu-a', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'zhouhu-a', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'zhouhu-a', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'zhouhu-a', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'zhouhu-a', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'zhouhu-a', 'block-right-hover.png')
      },
      {
        id: 'zhouhu-b',
        threatLevel: '中',
        type: '标准装备',
        name: '胄虎坦克 B型',
        number: 'OET-T01L',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '32.0t'
          },
          {
            name: '头顶高',
            value: '8.6m'
          },
          {
            name: '全重',
            value: '41.8t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '8.6m'
          },
          {
            name: '重量',
            value: '41.8t'
          }
        ],
        background: '“胄虎坦克”是民用履带底盘与军用机兵躯干拼凑而成的重型机体，通常搭载大型武装用于火力支援。',
        armedMessage: [
          '“苏安吉”突击榴弹炮：“苏安吉”突击榴弹炮是云回工业为同盟机兵设计的独特武装。该炮既可挂载于机体挂点，又能直接替换机体前臂降低重量，常作为同盟机兵手臂受损又缺乏备件时的应急替代。'
        ],
        modalAvatar: getImgSrc('pawn', 'zhouhu-b', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'zhouhu-b', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'zhouhu-b', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'zhouhu-b', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'zhouhu-b', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'zhouhu-b', 'block-right-hover.png')
      },
      //#endregion
      //#region 郊狼
      {
        id: 'jiaolang-a',
        threatLevel: '中',
        type: '防空装备',
        name: '郊狼 F型',
        number: 'SLM-M322',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '19.5t'
          },
          {
            name: '头顶高',
            value: '14.6m'
          },
          {
            name: '全重',
            value: '24.0t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.6m'
          },
          {
            name: '重量',
            value: '24.0t'
          }
        ],
        background: '“郊狼”是萨勒姆电气公司开发的二代机兵，彻底改良了前型“野牛”在南部战争期间暴露的不足，深受老兵信赖。',
        armedMessage: [
          '“守夜人”转管机炮 ：类似其他阵营的第一型手持式速射炮，联邦的“守夜人”也是由传统载具搭载的经典型号改装而来。其原型是某型历史悠久的三管航空机炮，无懈可击的经典设计在大灾难后仍未过时。',
          '“阿米特”轻型导弹：“阿米特”轻型导弹由联邦陆战队招标研发，其制导系统不易受EIC污染干扰，可在多数污染地带正常使用。联邦各军种均大量采购该型导弹，令赢得竞标的雷克森公司赚得盆满钵满。'
        ],
        modalAvatar: getImgSrc('pawn', 'jiaolang-a', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'jiaolang-a', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'jiaolang-a', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'jiaolang-a', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'jiaolang-a', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'jiaolang-a', 'block-right-hover.png')
      },
      {
        id: 'jiaolang-b',
        threatLevel: '中',
        type: '标准装备',
        name: '郊狼 S型',
        number: 'SLM-M322',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '19.5t'
          },
          {
            name: '头顶高',
            value: '14.6m'
          },
          {
            name: '全重',
            value: '24.0t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.6m'
          },
          {
            name: '重量',
            value: '24.0t'
          }
        ],
        background: '“郊狼”是萨勒姆电气公司开发的二代机兵，彻底改良了前型“野牛”在南部战争期间暴露的不足，深受老兵信赖。',
        armedMessage: [
          '“毒蝎”速射炮：“毒蝎”速射炮是联邦第一型专为机兵设计的手持武器，设计并不成熟，发射高膛压弹药时极易故障。该炮列装后仅配发减装药弹，威力有所降低，但因此轻中型机兵也能轻松搭载。',
          '“疣猪”格斗防盾：“疣猪”格斗防盾是为应对近战机兵威胁而列装的防御装备。理论上它也能高效抵御各类远程攻击，奈何相对有限的防御面积令理论与现实之间产生了深不见底的鸿沟。'
        ],
        modalAvatar: getImgSrc('pawn', 'jiaolang-b', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'jiaolang-b', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'jiaolang-b', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'jiaolang-b', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'jiaolang-b', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'jiaolang-b', 'block-right-hover.png')
      },
      {
        id: 'jiaolang-c',
        threatLevel: '中',
        type: '炮击装备',
        name: '郊狼 M型',
        number: 'SLM-M322',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '19.5t'
          },
          {
            name: '头顶高',
            value: '14.6m'
          },
          {
            name: '全重',
            value: '24.0t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.6m'
          },
          {
            name: '重量',
            value: '24.0t'
          }
        ],
        background: '“郊狼”是萨勒姆电气公司开发的二代机兵，彻底改良了前型“野牛”在南部战争期间暴露的不足，深受老兵信赖。',
        armedMessage: [
          '“驯兽师”榴弹炮：雷克森公司的“驯兽师”榴弹炮号称同口径全重最轻、威力最大，设计理念与战略同盟的欧冶电科不谋而合。配套的塑性高爆弹不仅适合打击无装甲目标，也足以粉碎机兵的装甲。'
        ],
        modalAvatar: getImgSrc('pawn', 'jiaolang-c', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'jiaolang-c', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'jiaolang-c', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'jiaolang-c', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'jiaolang-c', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'jiaolang-c', 'block-right-hover.png')
      },
      {
        id: 'jiaolang-d',
        threatLevel: '中',
        type: '突击装备',
        name: '郊狼 A型',
        number: 'SLM-M322',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '19.5t'
          },
          {
            name: '头顶高',
            value: '14.6m'
          },
          {
            name: '全重',
            value: '24.0t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.6m'
          },
          {
            name: '重量',
            value: '24.0t'
          }
        ],
        background: '“郊狼”是萨勒姆电气公司开发的二代机兵，彻底改良了前型“野牛”在南部战争期间暴露的不足，深受老兵信赖。',
        armedMessage: [
          '“猎狼犬”榴弹发射器：“猎狼犬”榴弹发射器是以机兵手持使用为前提开发的轻型武器，对载机平衡能力的影响较小，适合需要确保机动性的机体搭载。中、重型机体常双持使用，可兼顾火力与机动性。',
          '“阿米特”轻型导弹：“阿米特”轻型导弹由联邦陆战队招标研发，其制导系统不易受EIC污染干扰，可在多数污染地带正常使用。联邦各军种均大量采购该型导弹，令赢得竞标的雷克森公司赚得盆满钵满。'
        ],
        modalAvatar: getImgSrc('pawn', 'jiaolang-d', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'jiaolang-d', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'jiaolang-d', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'jiaolang-d', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'jiaolang-d', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'jiaolang-d', 'block-right-hover.png')
      },
      //#endregion
      //#region 郊狼混合型
      {
        id: 'jiaolang-hh-a',
        threatLevel: '中',
        type: '防空装备',
        name: '铜斑蛇混合型 F型',
        number: 'SLM-M323H',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '33.4t'
          },
          {
            name: '头顶高',
            value: '9.6m'
          },
          {
            name: '全重',
            value: '38.5t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '9.6m'
          },
          {
            name: '重量',
            value: '38.5t'
          }
        ],
        background: '“铜斑蛇混合型”是以举升底盘取代关节式步足的高机动实验型机兵，深受在战争中失去下肢但不愿退役的驾驶员喜爱。',
        armedMessage: [
          '“守夜人”转管机炮：类似其他阵营的第一型手持式速射炮，联邦的“守夜人”也是由传统载具搭载的经典型号改装而来。其原型是某型历史悠久的三管航空机炮，无懈可击的经典设计在大灾难后仍未过时。'
        ],
        modalAvatar: getImgSrc('pawn', 'jiaolang-hh-a', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'jiaolang-hh-a', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'jiaolang-hh-a', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'jiaolang-hh-a', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'jiaolang-hh-a', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'jiaolang-hh-a', 'block-right-hover.png')
      },
      {
        id: 'jiaolang-hh-b',
        threatLevel: '中',
        type: '支援装备',
        name: '铜斑蛇混合型 M型',
        number: 'SLM-M323H',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '33.4t'
          },
          {
            name: '头顶高',
            value: '9.6m'
          },
          {
            name: '全重',
            value: '38.5t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '9.6m'
          },
          {
            name: '重量',
            value: '38.5t'
          }
        ],
        background: '“铜斑蛇混合型”是以举升底盘取代关节式步足的高机动实验型机兵，深受在战争中失去下肢但不愿退役的驾驶员喜爱。',
        armedMessage: [
          '“驯兽师”榴弹炮：雷克森公司的“驯兽师”榴弹炮号称同口径全重最轻、威力最大，设计理念与战略同盟的欧冶电科不谋而合。配套的塑性高爆弹不仅适合打击无装甲目标，也足以粉碎机兵的装甲。'
        ],
        modalAvatar: getImgSrc('pawn', 'jiaolang-hh-b', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'jiaolang-hh-b', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'jiaolang-hh-b', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'jiaolang-hh-b', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'jiaolang-hh-b', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'jiaolang-hh-b', 'block-right-hover.png')
      },
      //#endregion
      //#region 轻剑
      {
        id: 'qingjian-a',
        threatLevel: '中',
        type: '突击装备',
        name: '轻剑 A型',
        number: 'UB-R01S',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '16.3t'
          },
          {
            name: '头顶高',
            value: '14.5m'
          },
          {
            name: '全重',
            value: '19.5t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.5m'
          },
          {
            name: '重量',
            value: '19.5t'
          }
        ],
        background: '“轻剑”是联合体陆军大量装备的二代机兵。得益于轻量级机身对关节器件负荷较小，该机即使缺乏维保也能长期运作。',
        armedMessage: [
          '“彗星”速射炮：“彗星”速射炮是米卡设计局的于灾前设计的手持式机炮，未雨绸缪的远见令人惊叹。该武装在二十年后的今天已经稍显落后，但它仍是多数联合体驾驶员训练期间接触的第一款武装。',
          '“飞蛾”轻型导弹：“飞蛾”轻型导弹是联合体海军舰艇配备的先进近防弹药，适合拦截快艇、机兵等中小型目标。为陆战机兵搭载该型导弹只是边境战争期间的应急之举，却意外取得了丰硕的战果。'
        ],
        modalAvatar: getImgSrc('pawn', 'qingjian-a', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'qingjian-a', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'qingjian-a', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'qingjian-a', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'qingjian-a', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'qingjian-a', 'block-right-hover.png')
      },
      {
        id: 'qingjian-b',
        threatLevel: '中',
        type: '通用装备',
        name: '轻剑 C型',
        number: 'UB-R01S',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '16.3t'
          },
          {
            name: '头顶高',
            value: '14.5m'
          },
          {
            name: '全重',
            value: '19.5t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.5m'
          },
          {
            name: '重量',
            value: '19.5t'
          }
        ],
        background: '“轻剑”是联合体陆军大量装备的二代机兵。得益于轻量级机身对关节器件负荷较小，该机即使缺乏维保也能长期运作。',
        armedMessage: [
          '“红鹳”能量机炮：“红鹳”能量机炮是严控了体积、重量和功耗的轻量级武装，适合轻型机兵搭载使用。相较于联合体的常规型号，该武装以一半负荷具备了八成作战效能，可谓工程学奇迹。',
          '“苍鹭”格斗防盾：轻便坚固的“苍鹭”格斗防盾为载机提供了应对近战攻击的手段。鉴于轻型机兵的机体结构通常相对脆弱，联合体军方并不推荐“轻剑”的驾驶员倚仗该武装与敌方近战机型长期缠斗。'
        ],
        modalAvatar: getImgSrc('pawn', 'qingjian-b', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'qingjian-b', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'qingjian-b', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'qingjian-b', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'qingjian-b', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'qingjian-b', 'block-right-hover.png')
      },
      {
        id: 'qingjian-d',
        threatLevel: '中',
        type: '重火力装备',
        name: '轻剑D型',
        number: 'UB-R01S',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '16.3t'
          },
          {
            name: '头顶高',
            value: '14.5m'
          },
          {
            name: '全重',
            value: '19.5t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.5m'
          },
          {
            name: '重量',
            value: '19.5t'
          }
        ],
        background: '“轻剑”是联合体陆军大量装备的二代机兵。得益于轻量级机身对关节器件负荷较小，该机即使缺乏维保也能长期运作。',
        armedMessage: [
          '“白鸽”火箭发射器：“白鸽”火箭发射器是少数适合轻型机兵使用的大口径武装之一。该武装采取多种手段将开火冲击抑制在不会损坏手臂关节的水平，令发射后替换受损手臂的方案完全丧失了竞争力。'
        ],
        modalAvatar: getImgSrc('pawn', 'qingjian-d', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'qingjian-d', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'qingjian-d', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'qingjian-d', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'qingjian-d', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'qingjian-d', 'block-right-hover.png')
      },
      {
        id: 'qingjian-tk-a',
        threatLevel: '中',
        type: '重火力装备',
        name: '轻剑坦克 D型',
        number: 'UB-R01SV',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '22.9t'
          },
          {
            name: '头顶高',
            value: '8.7m'
          },
          {
            name: '全重',
            value: '31.8t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '8.7m'
          },
          {
            name: '重量',
            value: '31.8t'
          }
        ],
        background: '“轻剑坦克”是边境战争期间由战损机兵与工程车底盘临时拼凑的改装机体，战后被作为火力支援型号生产。',
        armedMessage: [
          '“雌狐”榴弹炮：“雌狐”榴弹炮是一型射程和威力均较为优秀的大型火炮，但沉重炮身毫无便携性可言。现时联合体缺乏真正意义上的重型机体，该武装大多由轻剑坦克搭载。'
        ],
        modalAvatar: getImgSrc('pawn', 'qingjian-tk-a', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'qingjian-tk-a', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'qingjian-tk-a', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'qingjian-tk-a', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'qingjian-tk-a', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'qingjian-tk-a', 'block-right-hover.png')
      },
      {
        id: 'qingjian-tk-b',
        threatLevel: '中',
        type: '通用装备',
        name: '轻剑坦克 C型',
        number: 'UB-R01SV',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '22.9t'
          },
          {
            name: '头顶高',
            value: '8.7m'
          },
          {
            name: '全重',
            value: '31.8t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '8.7m'
          },
          {
            name: '重量',
            value: '31.8t'
          }
        ],
        background: '“轻剑”是联合体陆军大量装备的二代机兵。得益于轻量级机身对关节器件负荷较小，该机即使缺乏维保也能长期运作。',
        armedMessage: [
          '“飞蛾”轻型导弹：“飞蛾”轻型导弹是联合体海军舰艇配备的先进近防弹药，适合拦截快艇、机兵等中小型目标。为陆战机兵搭载该型导弹只是边境战争期间的应急之举，却意外取得了丰硕的战果。'
        ],
        modalAvatar: getImgSrc('pawn', 'qingjian-tk-b', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'qingjian-tk-b', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'qingjian-tk-b', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'qingjian-tk-b', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'qingjian-tk-b', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'qingjian-tk-b', 'block-right-hover.png')
      },
      //#endregion
      //#region 月露
      {
        id: 'yuelu',
        threatLevel: '中',
        type: '狙击装备',
        name: '月露',
        number: 'KMA-D202',
        modalAttrs: [
          {
            name: '生产商',
            value: '神谷重工'
          },
          {
            name: '空重',
            value: '15.8t'
          },
          {
            name: '头顶高',
            value: '15.6m'
          },
          {
            name: '全重',
            value: '20.5t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '15.6m'
          },
          {
            name: '重量',
            value: '20.5t'
          }
        ],
        background: '“月露”是名机“鸣神”的简化量产型号，虽取消了意识投影系统，但强大的狙击传感器没有任何缩水，仍能轻易地狙落对手。',
        armedMessage: [
          '一四式 长程射束炮“电光”：“电光”射束炮是一款为大规模量产而设计的精密狙击装备，以新型高导热聚合物直接铸造炮身加速线圈的主框架，令每一门“电光”都能保持不辱“神谷”之名的超高精度。',
          '一七式 光学迷彩“朝露”：“朝露”光学迷彩是神谷重工近年为其量产型二代机配套开发的隐身装置。羽州民间舆论常将岛舰发生的种种怪事归咎于“隐形机兵”，但岛舰防卫公司严正驳斥了这些无稽之谈。'
        ],
        modalAvatar: getImgSrc('pawn', 'yuelu', 'modal-avatar.png'),
        mecha: getImgSrc('pawn', 'yuelu', 'mecha.png'),
        blockLeft: getImgSrc('pawn', 'yuelu', 'block-left.png'),
        blockLeftHover: getImgSrc('pawn', 'yuelu', 'block-left-hover.png'),
        blockRight: getImgSrc('pawn', 'yuelu', 'block-right.png'),
        blockRightHover: getImgSrc('pawn', 'yuelu', 'block-right-hover.png')
      }
      //#endregion
    ]
  },
  {
    id: MECHA_LEVEL.ACE,
    name: locales.ace,
    mechaType: [
      //#region 威虎
      {
        id: 'weihu',
        threatLevel: '高',
        type: '工兵装备',
        name: '威虎',
        number: 'OET-T01G',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '30.0t'
          },
          {
            name: '头顶高',
            value: '14.4m'
          },
          {
            name: '全重',
            value: '36.0t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.4m'
          },
          {
            name: '重量',
            value: '36.0t'
          }
        ],
        background: '“威虎”是战略同盟装备量最大的第三代机兵，由前代“胄虎”和“伏虎”改装而来，多数部件均可通用，显著减轻了后勤压力。',
        armedMessage: [
          '“晚钟”重型战锤：显而易见，“晚钟”战锤是“晓钟”的后继型号，更为沉重的战斗部提高了攻击威力，但灵活性难免有所降低。据说其命名承载着让攻击对象睡个好觉的殷切期望，个中寓意令人暖心。',
          '“夜鹰”分束炮：“夜鹰”分束炮是路德马贝尔公司专为外贸市场研发的先进能量炮，可惜因高昂的价格而乏人问津。倘若你在某台机兵手中看到这款武装，它的主人绝对颇有些了不得的背景。',
          '“惊蛰”分束照射炮：“惊蛰”分束照射炮号称同盟工兵最先进的快速焊接装备，每一束重离子束流均可单独作业，加工效率数倍于旧型号。其切割模式解除安全限制后可用于自卫，威力不容小觑。',
          '“海蜃”烟幕散布器：   “海蜃”烟幕散布器是同盟新近列装的干扰装置，可妨碍敌方锁定。同盟军队严禁在居住区使用该武装以规避潜在的EIC污染风险，但其他用户显然不那么谨慎……'
        ],
        modalAvatar: getImgSrc('ace', 'weihu', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'weihu', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'weihu', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'weihu', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'weihu', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'weihu', 'block-right-hover.png')
      },
      //#endregion
      //#region 武人
      {
        id: 'wuren',
        threatLevel: '高',
        type: '格斗装备',
        name: '武人',
        number: 'OET-T02',
        modalAttrs: [
          {
            name: '生产商',
            value: '欧冶电子科技集团'
          },
          {
            name: '空重',
            value: '32.7t'
          },
          {
            name: '头顶高',
            value: '16.9m'
          },
          {
            name: '全重',
            value: '38.8t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '16.9m'
          },
          {
            name: '重量',
            value: '38.8t'
          }
        ],
        background: '“武人”是战略同盟重装部队少量装备的精锐机体，看似“伏虎”系列的新成员，却是另起炉灶的全新机体。 ',
        armedMessage: [
          '“明光”斩舰刀：“明光”斩舰刀是薪火重工在比弗罗斯特集团协助下研发的大型战机兵器，为近战机兵提供了对抗战舰和巨型机的手段。与同体型对手战斗时该武装破绽较大，只有高手才能驾驭。',
          '“爆破手”重型榴弹炮：“爆破手”榴弹炮是诺格系统公司产量最高的机兵手持式武装之一，属于无后坐力武器，有着与其粗笨外表并不相符的高度适装性，多数轻、中型机兵都能自如运用。',
          '“月华乙”防御力场：同盟为三代机兵配备的“月华乙”防御力场性能卓越，远非二代机兵使用的同型产品可比。可惜这完全得益于三代机兵强劲的引擎供电能力，并非力场技术在短短数年间有何突破。',
          '“凝云”瘫痪无人机：“凝云”无人机是同盟少数不拘泥于可量产性的尖端装备之一，可散布抑制EIC级联反应的电子烟幕压制一切以级联引擎供能的载具和设施，目标在烟幕内停留数秒就足以使之引擎停机。'
        ],
        modalAvatar: getImgSrc('ace', 'wuren', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'wuren', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'wuren', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'wuren', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'wuren', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'wuren', 'block-right-hover.png')
      },
      //#endregion
      //#region 雷龙
      {
        id: 'baolong',
        threatLevel: '高',
        type: '格斗装备',
        name: '雷龙',
        number: 'SLM-M337E',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '23.6t'
          },
          {
            name: '头顶高',
            value: '14.7m'
          },
          {
            name: '全重',
            value: '40.9t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.7m'
          },
          {
            name: '重量',
            value: '40.9t'
          }
        ],
        background: '该机是伪装成超重型机兵的中型机体，抛弃重达十吨的外甲模块后才会显露其敏捷凶悍的真正姿态。',
        armedMessage: [
          '“小猎犬”分束炮：“小猎犬”分束炮是联邦借鉴月海共同体相似型号开发的先进武器系统。以电磁力发射重离子的机制显著提高了机兵携弹量，适合长期作战，但发电功率较低的前代机兵无法承载。',
          '“短吻鳄”能量爆破炮：“短吻鳄”能量爆破炮不依赖传统炸药既可引发爆炸，是一种环境友好的新兴爆破技术——当然，这只是萨勒姆电气公司的一面之词，舆论对该武装潜在的重离子污染风险多有质疑。',
          '“纳古尔”伪装装甲：可抛弃装甲模块“纳古尔”赋予载机一键从重甲攻坚切换至轻装奔袭的多任务能力。装甲造型有意模仿了全球装备量最庞大的机兵“恐龙”，想必是出于“藏木于林”的考量。',
          '“格里芬”热能剑：“格里芬”热能剑是萨勒姆电气为该型机兵准备的秘密武器。时有敌军认为与这台火力怪兽交手时近身格斗更加有利，此时该机就可卸除重甲亮出双剑，出其不意地斩落对手。',
          '“灰鲭鲨”防御力场：“灰鲭鲨”防御力场可拦截多数远程武器的攻击，但受限于昂贵的价格只有少数精锐机兵得以配备。该机卸除外甲后引擎性能相当过剩，可以轻松驱动这台功耗惊人的设备。'
        ],
        modalAvatar: getImgSrc('ace', 'baolong', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'baolong', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'baolong', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'baolong', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'baolong', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'baolong', 'block-right-hover.png')
      },
      //#endregion
      //#region 异特龙
      {
        id: 'yitelong',
        threatLevel: '高',
        type: '',
        name: '异特龙',
        number: 'SLM-M336A2',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '131.2t'
          },
          {
            name: '头顶高',
            value: '23.9m'
          },
          {
            name: '全重',
            value: '168.0t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '23.9m'
          },
          {
            name: '重量',
            value: '168.0t'
          }
        ],
        background: '“异特龙”是萨勒姆电气顺应市场需求推出的外贸机体，以厚重的装甲为傲，高速行驶时单是撞击都有十足的威力。',
        armedMessage: [
          '“爆破手”重型榴弹炮：“爆破手”榴弹炮是诺格系统公司产量最高的机兵手持式武装之一，属于无后坐力武器，有着与其粗笨外型并不相符的高度适装性，多数轻、中型机兵都能自如运用。',
          '“阿米特”轻型导弹：“阿米特”轻型导弹由联邦陆战队招标研发，其制导系统不易受EIC污染干扰，可在多数污染地带正常使用。联邦各军种均大量采购该型导弹，令赢得竞标的雷克森公司赚得盆满钵满。',
          '“守护者S”附加防盾：“守护者S”附加防盾是路德马贝尔公司为联邦超重型机兵专门设计的披挂式防盾，各类变种常见于著名的“恐龙家族”，也可在民间防务公司千奇百怪的改装机兵上见到它的身影。',
          '“伏击者”地雷布撒器：“伏击者”地雷布撒器是联邦工兵常用的布雷装置。该武装可在“异特龙”高速突破敌方战线时沿途布撒地雷，伏击前来拦截的敌军——快反单位通常装甲薄弱，触雷一枚就会遭受重创。'
        ],
        modalAvatar: getImgSrc('ace', 'yitelong', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'yitelong', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'yitelong', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'yitelong', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'yitelong', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'yitelong', 'block-right-hover.png')
      },
      //#endregion
      //#region 铠燕
      {
        id: 'kaiyan',
        threatLevel: '高',
        type: '',
        name: '铠燕',
        number: 'MDB-VP31B',
        modalAttrs: [
          {
            name: '生产商',
            value: '水星设计局'
          },
          {
            name: '空重',
            value: '261.6t'
          },
          {
            name: '头顶高',
            value: '88.6m'
          },
          {
            name: '全重',
            value: '312.8t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '88.6m'
          },
          {
            name: '重量',
            value: '312.8t'
          }
        ],
        background: '“铠燕”是云回联邦开发的反装甲飞行器，主要用于压制和歼灭大规模机兵部队，为此配备了强大的火力。',
        armedMessage: [
          '“绣羽”火箭发射器：“绣羽”火箭发射器是同盟陆军航空兵的主力武装之一。据说它配套的高速火箭弹全数由库存无穷无尽的灾前库存改装而来，完全没有需要重新生产的迹象。',
          '“折柳”射束炮：“折柳”射束炮是同盟为大型舰机设计的定向能自卫武器，以极高的射击精度著称，甚至能从千米高空精确烧穿敌方炊事车的锅灶，史称“火锅战争”的短暂冲突便是因此而起。',
          '“尘网”烟幕导弹：“尘网”干扰导弹是同盟开发的防御武装，通过向载机四周发射导弹散布EIC尘屑，削弱和抵御能量武器的攻击。在同盟最新科技的加持下，该武装也兼具抑制级联引擎工作的独特机能。',
          '“山犬”攻击无人机：“山犬”攻击无人机常用于定点防卫，释放后会悬停于上空，发射高能射束狙击附近的敌方单位。无人机虽然火力强大但非常脆弱，即使只是被范围攻击波及也很容易损坏。'
        ],
        modalAvatar: getImgSrc('ace', 'kaiyan', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'kaiyan', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'kaiyan', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'kaiyan', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'kaiyan', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'kaiyan', 'block-right-hover.png')
      },
      //#endregion
      //#region 焰剑
      {
        id: 'yanjian',
        threatLevel: '高',
        type: '突击装备',
        name: '焰剑',
        number: 'UBP-F01S',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '29.2t'
          },
          {
            name: '头顶高',
            value: '14.9m'
          },
          {
            name: '全重',
            value: '35.6t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '14.9m'
          },
          {
            name: '重量',
            value: '35.6t'
          }
        ],
        background: '“焰剑”是由“轻剑”发展而来的第三代机兵，为对抗其他阵营的主力机型显著增加了装甲厚度和承载能力。',
        armedMessage: [
          '“爆破手D”双联榴弹炮：“爆破手D”榴弹炮是其单管版本的衍生型号，最简单粗暴的双管设计令火力密度近乎翻倍。它的重量显然超出许多轻型机兵的承载能力，但总有些大家伙青睐它充沛的火力。',
          '“洛伦兹”射束机炮：“洛伦兹”射束机炮诞生于月面配给战争期间，是全世界第一批投入实战的重离子束兵器。如今月面迎来暂时的和平，该武装常被降低功率后当作高性能打孔器使用。',
          '“海豚”照射炮：“海豚”照射炮威力较大但功耗惊人，为降低供电损耗采用了内嵌于机体、直连级联引擎的设计。该武装发射时的高热甚至会加热驾驶舱，必须加装液冷屏蔽层隔绝热量。',
          '“蜻蜓”微型导弹：“蜻蜓”微型导弹基于“以饱和攻击突破敌方拦截系统”的理念开发，通常用于打击防守严密的大型舰船或重甲机兵，但在部分老兵手中它也是能一举扫除大量目标的清屏好手。'
        ],
        modalAvatar: getImgSrc('ace', 'yanjian', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'yanjian', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'yanjian', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'yanjian', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'yanjian', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'yanjian', 'block-right-hover.png')
      },
      //#endregion
      //#region 雀鹰
      {
        id: 'queying-lj',
        threatLevel: '高',
        type: '特务装备',
        name: '雀鹰',
        number: 'UBP-R02E',
        modalAttrs: [
          {
            name: '生产商',
            value: '比弗罗斯特工业集团'
          },
          {
            name: '空重',
            value: '17.4t'
          },
          {
            name: '头顶高',
            value: '15.2m'
          },
          {
            name: '全重',
            value: '22.6t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '15.2m'
          },
          {
            name: '重量',
            value: '22.6t'
          }
        ],
        background: '“雀鹰”是“瓦尔文”系列机兵专供出口的定制型号，替换了部分设备防止关键技术泄露，性能略逊于联合体的自用版本。',
        armedMessage: [
          '“啄木鸟”速射炮：“啄木鸟”速射炮是联合体的新一代手持式机炮之一，因竞标落败转战出口市场，意外成为热门商品。这门短小精悍的轻型火炮稳定性极佳，最孱弱的民用机手臂都无需担忧其后坐力。',
          '“金丝雀”格斗防盾：“金丝雀”格斗防盾是联合体为“瓦尔文”系列可变机兵专门研发的轻型防盾，性能持平联合体陆军同类装备的同时自重极轻，不会成为载机高速飞行时的累赘。',
          '“椋鸟”多弹头导弹：“椋鸟”多弹头导弹是米卡设计局早年开发的杰作，边境战争期间曾令联邦的“恐龙”家族大感头痛，与“胡蜂”轻型导弹一同成为联邦陆军机兵格外强调对空拦截能力的主因。',
          '“灰背隼”离子爆破炮：“灰背隼”离子爆破炮是一门沉重的大威力武装。为便于轻巧的”瓦尔文“系列机体携带，该武装以经空气动力学优化的发泡金属外壳包覆炮身，放弃连射性能减轻散热系统重量。'
        ],
        modalAvatar: getImgSrc('ace', 'queying-lj', 'modal-avatar.png'),
        mecha: getImgSrc('ace', 'queying-lj', 'mecha.png'),
        blockLeft: getImgSrc('ace', 'queying-lj', 'block-left.png'),
        blockLeftHover: getImgSrc('ace', 'queying-lj', 'block-left-hover.png'),
        blockRight: getImgSrc('ace', 'queying-lj', 'block-right.png'),
        blockRightHover: getImgSrc('ace', 'queying-lj', 'block-right-hover.png')
      }
      //#endregion
    ]
  },
  {
    id: MECHA_LEVEL.BOSS,
    name: locales.boss,
    mechaType: [
      //#region 马卡鲁
      {
        id: 'makalu',
        threatLevel: '极高',
        type: '',
        name: '马卡鲁',
        number: 'SLM-M349T',
        modalAttrs: [
          {
            name: '生产商',
            value: '萨勒姆电气'
          },
          {
            name: '空重',
            value: '1,087.2t'
          },
          {
            name: '头顶高',
            value: '53.3m'
          },
          {
            name: '全重',
            value: '1,302.7t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '53.3m'
          },
          {
            name: '重量',
            value: '1,302.7t'
          }
        ],
        background: '“马卡鲁”是大洋联邦开发的庞然大物，曾现身于多场大规模冲突，骇人的巨躯有如毁灭化身，被其摧毁的机兵不计其数。',
        armedMessage: [
          '“主宰者”超级电浆炮：“主宰者”超级电浆炮是联邦为其巨型机兵设计的“怪兽”，火力媲美空舰的主炮。该武装具备照射和爆炸两种射击模式，可迅速摧毁一切目标，是“马卡鲁”的主要攻击手段。',
          '“复仇者”可变防盾：“复仇者”防盾可变形为热能格斗爪，多少弥补了“马卡鲁”不擅近距缠斗的短板。尽管这台巨型机兵很难准确击中脚边的骚扰者，但“命中即摧毁”的威慑力足以让多数敌人止步不前。',
          '“浩劫”照射炮组：“浩劫”照射炮组是“马卡鲁”最具代表性的武装。无数高能射束切裂天空点燃大地，焚毁视线所及的一切，骇人景象有如那梦魇般的“大灾难”再现于世，常能令敌人士气崩溃仓皇逃命。',
          '“阿米特”轻型导弹：“阿米特”轻型导弹配备了不易受EIC尘屑干扰的制导系统，可在多数高污染地带正常使用。“马卡鲁”常被投入围绕EIC资源展开的争夺战，因此大量搭载该型导弹应对敌群。',
          '“哨兵”防御力场无人机：“哨兵”无人机可张开防御力场为“马卡鲁”防御敌方的炮火。这台如小山般醒目的巨型机兵向来是敌方的重点关照对象，因此它搭载了最先进的防御武装，无惧多数常规火力的攻击。'
        ],
        modalAvatar: getImgSrc('boss', 'makalu', 'modal-avatar.png'),
        mecha: getImgSrc('boss', 'makalu', 'mecha.png'),
        blockLeft: getImgSrc('boss', 'makalu', 'block-left.png'),
        blockLeftHover: getImgSrc('boss', 'makalu', 'block-left-hover.png'),
        blockRight: getImgSrc('boss', 'makalu', 'block-right.png'),
        blockRightHover: getImgSrc('boss', 'makalu', 'block-right-hover.png')
      },
      //#endregion
      //#region 地狱猫
      {
        id: 'diyumao',
        threatLevel: '极高',
        type: '',
        name: '地狱猫',
        number: 'MDB-SV46',
        modalAttrs: [
          {
            name: '生产商',
            value: '米卡设计局'
          },
          {
            name: '空重',
            value: '753.5t'
          },
          {
            name: '头顶高',
            value: '129.3m'
          },
          {
            name: '全重',
            value: '923.1t'
          }
        ],
        attributes: [
          {
            name: '高度',
            value: '129.3m'
          },
          {
            name: '重量',
            value: '923.1t'
          }
        ],
        background: '“地狱猫”是月海共同体向联合体定制的特种机兵，号称单机匹敌整支空舰战斗群，性能超越了大洋联邦的同类机体。',
        armedMessage: [
          '“蜻蜓”微型导弹：“蜻蜓”微型导弹基于“以饱和攻击突破敌方拦截系统”的理念开发，通常用于打击防守严密的大型舰船或重甲机兵，但在部分老兵手中它也是能一举扫除大量目标的清屏好手。',
          '“猛毒”电浆爆破炮：“猛毒”电浆爆破炮是昂贵而精密的重型炮击武装，具备爆破和贯穿两种射击模式。这门巨炮无论功耗还是重量都远超常规机兵的承载能力，唯有某些“大家伙”能运用自如。',
          '“睡鼠”侵蚀力场：“睡鼠”侵蚀力场是由一对大型无人机部署的禁锢装置，张开静滞力场封锁目标行动的同时散布超微单元破坏其内部结构。受害者即使侥幸打破封锁，战斗能力也会遭到显著削弱。',
          '“羚羊”机动增幅组件：“羚羊”机动增幅组件是应用了举升技术的新型推进系统，不仅令沉重的“地狱猫‘具备了难以想象的惊人机动性，高速移动时遗留的超微单元还会留下残像欺骗敌方的火控系统。',
          '“丁格犬”分束照射炮：“丁格犬”分束照射炮基于冲入敌阵后扫除周围一切威胁的想定而设计，以一敌多时最有利于发挥其骇人的火力。严格来说该武装并非“分束炮”，而是一组具备独立火控的小型照射炮群。'
        ],
        modalAvatar: getImgSrc('boss', 'diyumao', 'modal-avatar.png'),
        mecha: getImgSrc('boss', 'diyumao', 'mecha.png'),
        blockLeft: getImgSrc('boss', 'diyumao', 'block-left.png'),
        blockLeftHover: getImgSrc('boss', 'diyumao', 'block-left-hover.png'),
        blockRight: getImgSrc('boss', 'diyumao', 'block-right.png'),
        blockRightHover: getImgSrc('boss', 'diyumao', 'block-right-hover.png')
      },
      //#endregion
      //#region 康斯坦丁
      {
        id: 'kangsitanding',
        threatLevel: '极高',
        type: '',
        name: '康斯坦丁',
        number: 'LTM-LS341',
        modalAttrs: [
          {
            name: '生产商',
            value: '路德马贝尔'
          },
          {
            name: '空重',
            value: '19,700t'
          },
          {
            name: '全长',
            value: '554.1m'
          },
          {
            name: '全重',
            value: '24,500t'
          }
        ],
        attributes: [
          {
            name: '全长',
            value: '554.1m'
          },
          {
            name: '重量',
            value: '24,500t'
          }
        ],
        background: '“康斯坦丁”是为突破要塞设计的高速登陆舰，不仅能穿过敌军炮火将机兵投送至最前线，还具备极为强大的火力。',
        armedMessage: [
          '“蹂躏者”火力系统：“蹂躏者”火力系统包括一系列大、中口径舰炮，尤其适合摧毁战舰和坚固工事。联邦登陆舰肩负投送机兵部队后为其提供近距火力支援的职责，配备了媲美主力舰的炮击火力。',
          '“外交官”拦截系统：“外交官”拦截系统是联邦陆战队为其海空舰队配备的多层防御体系，构成系统的近防导弹和中、小口径速射炮由中枢火控统一调度，自动攻击逼近战舰的敌方目标，无需人工干预。',
          '“猎鹿犬”多弹头导弹：“猎鹿犬”多弹头导弹是联邦陆战队的主力舰载导弹之一。该武装常拆除战斗部后装载需要向前线部队紧急投送的补给，拆下的子弹头也可作为陆军通用发射器的弹药，运用相当灵活。',
          '“阿米特”轻型导弹：“阿米特”轻型导弹由联邦陆战队招标研发，其制导系统不易受EIC污染干扰，可在多数污染地带正常使用。联邦各军种均大量采购该型导弹，令赢得竞标的雷克森公司赚得盆满钵满。'
        ],
        modalAvatar: getImgSrc('boss', 'kangsitanding', 'modal-avatar.png'),
        mecha: getImgSrc('boss', 'kangsitanding', 'mecha.png'),
        blockLeft: getImgSrc('boss', 'kangsitanding', 'block-left.png'),
        blockLeftHover: getImgSrc('boss', 'kangsitanding', 'block-left-hover.png'),
        blockRight: getImgSrc('boss', 'kangsitanding', 'block-right.png'),
        blockRightHover: getImgSrc('boss', 'kangsitanding', 'block-right-hover.png')
      },
      //#endregion
      //#region 莫雷纳
      {
        id: 'moleina',
        threatLevel: '极高',
        type: '',
        name: '莫雷纳',
        number: '不明',
        modalAttrs: [
          {
            name: '生产商',
            value: '不明'
          },
          {
            name: '空重',
            value: '不明'
          },
          {
            name: '全长',
            value: '不明'
          },
          {
            name: '全重',
            value: '不明'
          }
        ],
        attributes: [
          {
            name: '全长',
            value: '不明'
          },
          {
            name: '重量',
            value: '不明'
          }
        ],
        background: '“莫雷纳”是来路不明且极度危险的异形机兵，许多部件能看出联邦机型的影子，但东拼西凑的构造不似正规厂商所为。',
        armedMessage: [
          '“刺针”尾部分束炮：“刺针”分束炮由一支联邦调查队最早记录并命名。其技术特征类似联邦路德马贝尔公司的产品，但联邦军方已确认该公司从未生产同型武器，疑似有敌对势力窃取了相关技术。',
          '“红眼”反射无人机：“红眼”反射无人由一支联邦调查队最早记录并命名，是配合分束炮运用的悬浮式电磁反射装置。据分析其电磁频谱特征类似联合体的同类装备，但它的机械构造不同于任何已知型号。'
        ],
        modalAvatar: getImgSrc('boss', 'moleina', 'modal-avatar.png'),
        mecha: getImgSrc('boss', 'moleina', 'mecha.png'),
        blockLeft: getImgSrc('boss', 'moleina', 'block-left.png'),
        blockLeftHover: getImgSrc('boss', 'moleina', 'block-left-hover.png'),
        blockRight: getImgSrc('boss', 'moleina', 'block-right.png'),
        blockRightHover: getImgSrc('boss', 'moleina', 'block-right-hover.png')
      }
      //#endregion
    ]
  }
];

// 威胁等级map
const threatLevelMapLocale = {
  中: 'threatLevelMedium',
  高: 'threatLevelHigh',
  极高: 'threatLevelExtreme'
};

// 同步本地化数据
airmen = locales.arimen.map(level => {
  const localeMechaType = level.mechaType;
  const mechaType = airmen.find(i => i.id === level.id).mechaType;
  const _level = {
    id: level.id,
    name: locales[level.id],
    mechaType: localeMechaType.filter(localeMechaInfo => Boolean(mechaType.find(i => i.id === localeMechaInfo.id))).map(localeMechaInfo => {
      const mechaInfo = mechaType.find(i => i.id === localeMechaInfo.id);
      return Object.assign({}, mechaInfo, localeMechaInfo, {
        threatLevel: locales[threatLevelMapLocale[mechaInfo.threatLevel]]
      });
    })
  };
  return _level;
});

// console.log(locales.arimen, airmen);

export const AIRMEN = airmen;

/**
 * @typedef {Object} PageEnum
 * @property {string} LEVEL 机兵等级页面
 * @property {string} MECHA_TYPE 机兵类型页面
 *
 * @type {PageEnum}
 * @description 机兵页面枚举
 */
export const PAGE_ENUM = {
  LEVEL: 'level',
  MECHA_TYPE: 'mechaType'
};

/**
 * @description 机兵等级数据
 */
export const LEVEL_BLOCK = {
  left: {
    level: MECHA_LEVEL.PAWN,
    position: 'left',
    name: locales[threatLevelMapLocale['中']],
    normal: getImgSrc('pawn', '', 'block.png'),
    hover: getImgSrc('pawn', '', 'block-hover.png')
  },
  center: {
    level: MECHA_LEVEL.ACE,
    position: 'center',
    name: locales[threatLevelMapLocale['高']],
    normal: getImgSrc('ace', '', 'block.png'),
    hover: getImgSrc('ace', '', 'block-hover.png')
  },
  right: {
    level: MECHA_LEVEL.BOSS,
    position: 'right',
    name: locales[threatLevelMapLocale['极高']],
    normal: getImgSrc('boss', '', 'block.png'),
    hover: getImgSrc('boss', '', 'block-hover.png')
  }
};
